import React, { FC } from 'react'

import { IconBarChart } from '@avantstay/backoffice-vectors'

import { DataResultMessage } from '../../DataResultMessage'
import * as S from './EmptyDataMessage.styles'

export const EmptyDataMessage: FC = () => {
  const emptyDataConfig = {
    messageTitle: 'No data to display',
    message: 'We have no data to display, please check back later.',
  }

  return (
    <S.EmptyWrapper>
      <DataResultMessage {...emptyDataConfig} titleIcon={<IconBarChart />} />
    </S.EmptyWrapper>
  )
}
